import { Card, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { useTheme } from 'antd-style'

import { GetRecipeMedicationDispenseResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  medicationDispenses: GetRecipeMedicationDispenseResponse[]
}

export const PrescriptionItemsCard = ({ medicationDispenses }: Props) => {
  const { t } = useLocales()
  const palette = useTheme()

  const columns: ColumnsType<GetRecipeMedicationDispenseResponse> = [
    {
      key: 'name',
      title: t('recipes.commercial_name'),
      render: (_, { internalInventoryItem }) => (
        <Text color={palette.blue6}>
          {internalInventoryItem?.product?.name}
        </Text>
      )
    },
    {
      key: 'unit',
      title: t('common.unit'),
      render: (_, { internalInventoryItem }) => (
        <Text color={palette.cyan7}>
          {internalInventoryItem?.productForm?.name}
        </Text>
      )
    },
    {
      key: 'quantity',
      title: t('recipes.requested_quantity'),
      dataIndex: 'dispensedAmount'
    }
  ]

  return (
    <Card>
      <Card title={t('stock_applications.requested_medicine')}>
        <Table
          bordered
          rowKey={(record) => JSON.stringify(record)}
          dataSource={medicationDispenses}
          columns={columns}
          scroll={{ x: 'max-content' }}
          pagination={false}
        />
      </Card>
    </Card>
  )
}
